(function () {
  'use strict';

  if (window.AMStickyAtc) return;
  window.AMStickyAtc = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element && event.target.closest('[data-am-sticky-atc-button]');
    const block = trigger && trigger.closest('.buy-buttons-block');
    if (!block) return;

    const button = block.querySelector('add-to-cart-component button[name="add"]');
    if (!button) {
      block.querySelector('form[data-type="add-to-cart-form"]')?.requestSubmit();
    } else if (!button.disabled) {
      button.click();
    }
  });
})();
